import { tz } from "@date-fns/tz";
import { Grid2, Typography } from "@mui/material";
import { format } from "date-fns";

import { useFiltersContext } from "components/contexts";
import { useFormatMessage } from "lang";
import { getSelectedPowerPlant, useAppSelector } from "store";

export const ForecastTitle = () => {
  const formatMessage = useFormatMessage();
  const { date } = useFiltersContext();
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);
  const timezone = tz(selectedPowerPlant?.timezone || "Europe/Warsaw");

  return (
    <Grid2 container spacing={0} justifyContent={"space-between"}>
      <Typography
        variant="h4"
        component="div"
        color="primary"
        fontSize={28}
        lineHeight={0.9}
        fontWeight={900}
      >
        {formatMessage("pageTitle.forecast")}
      </Typography>
      <Grid2
        container
        flexDirection={"column"}
        spacing={0}
        alignItems={"flex-end"}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            lineHeight: 0.9,
            fontSize: 26,
            textTransform: "capitalize",
            color: "text.secondary",
          }}
        >
          {format(date.day, "EEEE", { in: timezone })}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: 20,
            color: "text.secondary",
          }}
        >
          {format(date.day, "PPP", { in: timezone }).split(" ").slice(0, -1).join(" ")}
        </Typography>
      </Grid2>
    </Grid2>
  );
};
